import { useState, useEffect } from 'react';
import BoxStock from './component/BoxStock.component';
import { TitleStock, ContainerHeader, NoStockExists, CdBoxContentContainer, CdBoxContent, IconBox, TextContent } from './component/ContentStock';
import { getStock } from "./Stock.service";
import { SearchProduct } from "../interface/SearchProdutc";
import Progress from "../../../../component/progress/Progress.component";
import { Container } from "../../../../component/container/Container";
import { useStore } from '../../../../context/Store';
import { AxiosError } from "axios";
import GridComponent from '../../../../component/grid/GridComponent.component';
import { ESTOQLJPROXIMAS, Stock } from './interface/Stock';
import { StockComponentInterface } from './interface/StockComponent';
import { BiStoreAlt } from 'react-icons/bi';

import TruckIcon from '../../../../assets/icon/Truck.svg';

export default function StockComponent({ product, handleStoreStock }: StockComponentInterface) {

  const [nearbyStoresStock, setNearbyStoresStock] = useState<ESTOQLJPROXIMAS[]>([]);
  const [stock, setStock] = useState<Stock | undefined>({} as Stock);
  const [reloadStock, setReloadStock] = useState<boolean>(true);
  const { store, nameStore } = useStore();

  useEffect(() => {
    const productAux: SearchProduct = {
      mercadoria: product?.MATNR || '',
      nrloja: store || '',
      embvenda: product?.MEINS
    }
    responseStock(productAux);
  }, []);

  const responseStock = async (product: SearchProduct) => {
    await getStock([product]).then((response) => {
      setNearbyStoresStock(response.data.eT_ESTOQLJPROXIMAS);
      setStock(response.data.eT_ESTOQUE.shift());
    }).catch((error: AxiosError) => {
      console.log(error.response?.data);
    }).finally(() => {
      setReloadStock(false);
    })
  }

  if (reloadStock) {
    return <Container margin="40px 0px 0px 0px"><Progress open={reloadStock} position="relative" /></Container>
  }

  if (nearbyStoresStock.length < 1) {
    return <NoStockExists>Sem estoques disponíveis em lojas próximas.</NoStockExists>
  }

  return (
    <>
      <ContainerHeader>
        <TitleStock>Lojas com Estoques Disponíveis</TitleStock>
        <CdBoxContentContainer>
          <CdBoxContent><IconBox><img src={TruckIcon} alt={TruckIcon} /></IconBox><TextContent>{stock?.cD_NOME} : {stock?.estoquecddisp} {stock?.embvenda}</TextContent></CdBoxContent>
          <CdBoxContent onClick={() => handleStoreStock(store)} style={{ cursor: 'pointer' }}><IconBox><BiStoreAlt size={25} color={'#FFFF'} /></IconBox><TextContent>Retornar para loja: <b>{store}- {nameStore}</b></TextContent></CdBoxContent>
        </CdBoxContentContainer>
      </ContainerHeader>
      <GridComponent spacing={1}>

        {nearbyStoresStock.map((item: ESTOQLJPROXIMAS, index: number) => {
          const address: string = `${item.nrlojaproX_ENDERECO}, ${item.nrlojaproX_CIDADE}, ${item.nrlojaproX_BAIRRO}, ${item.nrlojaproX_UF}`;
          return (
            <BoxStock
              onClick={() => handleStoreStock(item.nrlojaprox)}
              name={`${item.nrlojaproX_NOME}`}
              address={address}
              quantity={item.estoqueljdisp}
              key={`table-row-stock-next-${index}`} />
          )
        })}
      </GridComponent>
    </>
  )
}
